import gql from 'graphql-tag'

export RootQuery = gql """
	query ProjectLegalRoot(
		$projectSlug: String!,
		$inboxFilters: LegalDocumentsFilters,
		$registryFilters: LegalDocumentsFilters,
		){
		project(slug: $projectSlug) {
			id
			name
			slug
			code
			city
			country
			inboxCount: legalDocumentsCount(filters: $inboxFilters)
			registryCount: legalDocumentsCount(filters: $registryFilters)
		}
	}
"""
